


















import { General } from "@/utils/constants";

export default {
  name: "PageByNumber",
  model: {
    prop: "value",
    event: "update"
  },

  props: {
    value: {
      type: [String, Number],
      default: 1
    },
    numberOfPages: {
      type: Number,
      default: 10
    }
  },

  data() {
    return {
      General,
      inputValue: 1
    };
  },

  computed: {
    currentPage: {
      get() {
        return this.numberOfPages > 0 ? this.value : 0;
      },
      set(newValue: number) {
        this.inputValue = newValue;
      }
    }
  },

  methods: {
    sendValue() {
      if (this.inputValue < 1) this.inputValue = 1;
      else if (this.inputValue > this.numberOfPages)
        this.inputValue = this.numberOfPages;
      this.$emit("update", Number(this.inputValue));
    }
  }
};
